import { render } from "./LoanDetails.vue?vue&type=template&id=d0bace9c&scoped=true"
import script from "./LoanDetails.vue?vue&type=script&lang=js"
export * from "./LoanDetails.vue?vue&type=script&lang=js"

import "./LoanDetails.vue?vue&type=style&index=0&id=d0bace9c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0bace9c"]])

export default __exports__